import vert from '@/shaders/question/question.vert' 
import frag from '@/shaders/question/question.frag'
 
import ImageService from '@/services/ImageService'
import EventEmitter from 'src/helpers/EventEmitter'
import store from 'src/store'

const THREE = require('three')
import { TweenMax, ColorPropsPlugin } from 'gsap/all'
  
class Bg extends THREE.Group { 

  constructor(config) {

    super();
  
    Object.assign(this, EventEmitter)  
 
    // INIT
    this.clock = new THREE.Clock() 
    this.STATES = store.state.question.STATES; 
    this.initalShow = true;
    this.colorProp = ColorPropsPlugin; 
 
    // MESH     
    this.setupMesh();
 
    // START
    this.resize() 
  }

  setupMesh() { 
 
    let images = [
      
      require('@/assets/img/question/result/bg/01_furious.jpg'), 
      require('@/assets/img/question/result/bg/02_sad.jpg'), 
      require('@/assets/img/question/result/bg/03_angry.jpg'), 
      require('@/assets/img/question/result/bg/04_agitated.jpg'), 
      require('@/assets/img/question/result/bg/05_confused.jpg'), 
      require('@/assets/img/question/result/bg/06_mildly-amused.jpg'),
      require('@/assets/img/question/result/bg/07_amused.jpg'), 
      require('@/assets/img/question/result/bg/08_happy.jpg'), 
      require('@/assets/img/question/result/distortion/amethyst.png'),
      //require('@/assets/img/question/result/bg/09_ecstatic.jpg'), 
 
      require('@/assets/img/question/result/bg/error.png') 

    ]

    this.textures = [];
    for (var i = 0; i < images.length; i++) {
      let texture = this.createTexture(images[i]);
      this.textures.push( texture );
    } 

    let distortion_images = [
      require('@/assets/img/question/result/distortion/amethyst.png'), 
      require('@/assets/img/question/result/distortion/oxyer.png'), 
      require('@/assets/img/question/result/distortion/rocks.png'),
      require('@/assets/img/question/result/distortion/face.jpg'),
      require('@/assets/img/question/result/distortion/pixel.jpg'),
      require('@/assets/img/question/result/distortion/mellow.jpg')
    ]

    this.distortion_textures = [];
    for (var i = 0; i < distortion_images.length; i++) {
      let texture = this.createTexture(distortion_images[i]);
      texture.wrapS = THREE.MirroredRepeatWrapping;
      texture.wrapT = THREE.MirroredRepeatWrapping;
      this.distortion_textures.push( texture );
    } 
 
   
    this.tweenObj = {
      startColor: '#88dfff' ,
      endColor: '#0095cc' 
    }

    var geometry = new THREE.PlaneBufferGeometry(1 , 1  , 1);
    this.material = new THREE.ShaderMaterial({
      vertexShader : vert,
      fragmentShader : frag,
      transparent: true,
      uniforms : {
        startColor :{ 
          value : new THREE.Color(this.tweenObj.startColor)
        },
        endColor :{ 
          value : new THREE.Color(this.tweenObj.endColor)
        },
        tDistortion: {
          value: this.distortion_textures[0],
          type: "t"
        },
        tDrawing: {
          value: this.textures[0],
          type: "t"
        }, 
        time :{
          type : "f",
          value : 0
        },
        mixAmt :{
          type : "f",
          value : 0
        }
      }
    });
    this.solidmesh = new THREE.Mesh(geometry, this.material);
    this.solidmesh.position.z = -400;
    this.solidmesh.position.y = 50; 
    this.solidmesh.scale.x = 1024 * 0.5;
    this.solidmesh.scale.y = 1024 * 0.5; 

    this.add(this.solidmesh);
  }

  animateTo(start, end, duration, ease){ 
    TweenMax.to(this.tweenObj, duration, {
      colorProps:{
        startColor: start,
        endColor: end
      },
      ease: ease,
      onUpdate: () => {
        this.material.uniforms.startColor.value = new THREE.Color(this.tweenObj.startColor) 
        this.material.uniforms.endColor.value = new THREE.Color(this.tweenObj.endColor) 
      }
    });
  }

  createTexture(url){
    let img = ImageService.get(url) 
    let texture = new THREE.Texture(img); 
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;  
    texture.needsUpdate = true;
    return texture;
  }

  confused(){
    this.timeline.play(); 
  }

  idle() {  
    let start =  '#b5287b';
    let end =  '#d83695';
    let duration = this.initalShow ? 4 : 1;
    let ease = this.initalShow ? 'Power3.easeIn' : 'Power4.easeOut';
    //this.animateTo(start, end, duration, ease)
    this.initalShow = false;

    TweenMax.to(this.material.uniforms.mixAmt, duration, { 
      value: 0.0
    }); 
  }

  tapholdProgress() {
    let start =  '#f9f4e0';
    let end =  '#f9f4e0'; 
    this.animateTo(start, end, 0.5, 'Quad.easeOut')
  }
  
  tapholdRecord() {}

  tapholdRelease() {

    let start =  '#88dfff';
    let end =  '#0095cc'; 
    this.animateTo(start, end, 0.5, 'Quad.easeInOut')
  }
    
  processing() {}
  
  result() {}
    
  complete(val) { 

    let start = '';
    let end = '';

    switch(val) {
      case 0:
        start =  '#ff0000';
        end =  '#260032';
        this.material.uniforms.tDistortion.value = this.distortion_textures[0]; 
        this.furious();
        break;
      case 1:
        start =  '#9f02e0';
        end =  '#47cdff';
        this.material.uniforms.tDistortion.value = this.distortion_textures[1]; 
        this.sad();
        break;
      case 2:
        start =  '#ff3232';
        end =  '#ff7b42';
        this.material.uniforms.tDistortion.value = this.distortion_textures[3]; 
        this.angry();
        break;
      case 3:
        start =  '#fe4296';
        end =  '#ffef86';
        this.agitated();
        break;
      case 4:
        start =  '#5cc7ff';
        end =  '#fe93db';
        this.material.uniforms.tDistortion.value = this.distortion_textures[4]; 
        this.confused();
        break;
      case 5:
        start =  '#f9f4e0';
        end =  '#93fee3';
        this.material.uniforms.tDistortion.value = this.distortion_textures[5]; 
        this.mildlyamused();
        break;
      case 6:
        start =  '#23f7ff';
        end =  '#93fee3';
        this.material.uniforms.tDistortion.value = this.distortion_textures[5]; 
        this.amused();
        break;
      case 7:
        start =  '#36ff8b';
        end =  '#5dffd7 ';
        this.material.uniforms.tDistortion.value = this.distortion_textures[5]; 
        this.happy();
        break;
      case 8:
        start =  '#33ffff';
        end =  '#ffcda9';
        this.material.uniforms.tDistortion.value = this.distortion_textures[4]; 
        this.ecstatic();
        break;
      case 9:
        start =  '#f9f4e0';
        end =  '#f9f4e0';
        this.material.uniforms.tDistortion.value = this.distortion_textures[3]; 
        this.error();
        break;
    }

    //this.animateTo(start, end, 3, 'Expo.easeOut')
    this.updateTexture(val);

    TweenMax.to(this.material.uniforms.mixAmt, 1, { 
      value: 1.0, 
    }); 
  }

  furious(){ }

  sad(){ }

  angry(){ }

  agitated(){ }

  confused(){ }

  mildlyamused(){ }
  
  amused(){ }

  happy(){ }

  ecstatic(){ }
  
  error(){ 
    // let start =  '#f9f4e0';
    // let end =  '#f9f4e0';
    // this.animateTo(start, end)
  }

  setTextures(startTex, endTex){
    // this.material.uniforms.startTex.value = startTex;
    // this.material.uniforms.endTex.value = endTex;
  }

  tick() { 
    this.material.uniforms.time.value -= 0.001; 
  }
  
  updateTexture(index){
    this.material.uniforms.tDrawing.value = this.textures[index]; 
  }

  updateState(val){ 
    // if( val === this.STATES.COMPLETE){
    //   this.mesh.visible = true; 
    // } else {
    //   this.mesh.visible = false;
    // } 
  }

  updateRoute(val) {
    if(val.name === 'question'){
      TweenMax.to(this.solidmesh.scale, 3, {
        x: 1250,
        y: 1250,
        ease: 'Expo.easeInOut'
      })
    } else if(val.name === 'result'){

      TweenMax.to(this.material.uniforms.mixAmt, 1, { 
        value: 0.07
      });
      this.animateTo('#88dfff', '#0095cc', 1, 'Quad.easeOut') 
    }
  }
 
  resize() { 
    
    // this.mesh.scale.x = window.innerWidth * 1.5;
    // this.mesh.scale.y = window.innerHeight * 1.5; 


  }
 
 
}

export default Bg